import React from "react"

export const PayeeScreen = ({ user }) => {
  return <div>PAYEE</div>
}

export default PayeeScreen
